'use strict';

var plyr = require('plyr');

var Player = function() {
  var self = this;

  self.init = function() {
    plyr.setup({loadSprite: false});
  }
};

module.exports = Player;
